import React from "react";
import DashboardSection from "src/components/Dashboards/DashboardSection";

const dashboards = () => {
  return <DashboardSection />;
};

export default dashboards;
